import { isEmpty } from "lodash";
import { doctor, getCurrentUserRole } from "modules/utilities/utility";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useDoctorSlot, useGenerateCartLink } from "./store";
import useDoctorDashboardStore from "modules/all_doctor_dashboard/store";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PlacedOrderForm({
  cart,
  case_id,
  setShow,
  showCopy,
  cartValue,
  canSubmit,
  isLoading,
  orderLink,
  setToaster,
  copyButton,
  setShowCopy,
  handleSubmit,
  setCanSubmit,
  customerDetails,
  placeOrderStatus,
  handleCopyOrderLink,
  handleCustomerDetailChanges,
}) {
  const { markDoctorSlotFinished } = useDoctorSlot();

  useEffect(() => {}, [case_id, customerDetails]);
  const { productCanvas, bookingId, generateCartLink } = useGenerateCartLink();

  const [isPhoneValid, setIsPhoneValid] = useState(true);
  const [isEmailValid, setIsEmailValid] = useState(true);

  useEffect(() => {
    // Validate phone number
    const phoneRegex = /^(\+91)?[0-9]{10}$/;
    setIsPhoneValid(phoneRegex.test(customerDetails.phone));

    // Validate email
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // General email format
    setIsEmailValid(emailRegex.test(customerDetails.email));
  }, [customerDetails.phone, customerDetails.email]);

  const handleDispose = () => {
    markDoctorSlotFinished(
      bookingId,
      {
        bookingId,
        comment: "answered",
        unanswered: false,
      },
      toast
    );
    setShow(false);
  };

  return (
    <div className="m-2 border rounded px-4 pt-3 pb-3 shadow">
      <Form onSubmit={handleSubmit}>
        {!doctor.includes(getCurrentUserRole()) && (
          <>
            <Row className="mb-2 g-3">
              <Form.Group as={Col} controlId="formGridName">
                <Form.Control
                  type="text"
                  placeholder="Enter Name"
                  disabled
                  value={
                    customerDetails.first_name
                  }
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridName">
                <Form.Control
                  type="text"
                  placeholder="Phone Number"
                  defaultValue={customerDetails.phone}
                  disabled
                  onChange={(e) =>
                    handleCustomerDetailChanges("phone", e.target.value)
                  }
                  isInvalid={!isPhoneValid}
                />
                <Form.Control.Feedback type="invalid">
                  Invalid phone number. Please enter a 10-digit phone number.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  defaultValue={customerDetails.email}
                  disabled
                  onChange={(e) =>
                    handleCustomerDetailChanges("email", e.target.value)
                  }
                  isInvalid={!isEmailValid}
                />
                <Form.Control.Feedback type="invalid">
                  Invalid email address format.
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-2 g-3">
              <Form.Group as={Col} controlId="formGridAddress1">
                <Form.Label>Address line 1</Form.Label>
                <Form.Control
                  required
                  placeholder="1234 Main St"
                  defaultValue={customerDetails.address1}
                  onChange={(e) =>
                    handleCustomerDetailChanges("address1", e.target.value)
                  }
                  isInvalid={customerDetails?.address1?.length <= 30}
                />
                <Form.Control.Feedback type="invalid">
                  Address line 1 must be at least 30 characters long.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} controlId="formGridAddress2">
                <Form.Label>Address line 2</Form.Label>
                <Form.Control
                  required
                  placeholder="Apartment, studio, or floor"
                  defaultValue={customerDetails.address2}
                  onChange={(e) =>
                    handleCustomerDetailChanges("address2", e.target.value)
                  }
                />
              </Form.Group>

              <Form.Group as={Col} controlId="formGridCity">
                <Form.Label>Country</Form.Label>
                <Form.Control
                  required
                  defaultValue={customerDetails.country}
                  onChange={(e) =>
                    handleCustomerDetailChanges("country", e.target.value)
                  }
                />
              </Form.Group>
            </Row>
            <Row className="mb-2 g-3">
              <Form.Group as={Col} controlId="formGridCity">
                <Form.Label>City</Form.Label>
                <Form.Control
                  required
                  defaultValue={customerDetails.city}
                  onChange={(e) =>
                    handleCustomerDetailChanges("city", e.target.value)
                  }
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridState">
                <Form.Label>Province</Form.Label>
                <Form.Control
                  required
                  defaultValue={customerDetails.province}
                  onChange={(e) =>
                    handleCustomerDetailChanges("province", e.target.value)
                  }
                />
              </Form.Group>
              <Form.Group as={Col} controlId="formGridZip">
                <Form.Label>Zip</Form.Label>
                <Form.Control
                  required
                  defaultValue={customerDetails.zip}
                  onChange={(e) =>
                    handleCustomerDetailChanges("zip", e.target.value)
                  }
                />
              </Form.Group>
            </Row>
          </>
        )}
        <Row className="mx-1">
          {!isEmpty(cart) && canSubmit ? (
            <div className="d-flex justify-content-end gap-3 p-0">
              {!doctor.includes(getCurrentUserRole()) && (
                <Button
                  className="m-0 w-50"
                  variant={placeOrderStatus.variant}
                  id="place-order"
                  key= "place-order"
                  type="submit"
                  disabled={!isPhoneValid || !isEmailValid} // Disable if phone or email is invalid
                >
                  {isLoading && <Spinner size="sm" />}
                  {placeOrderStatus.text}
                </Button>
              )}
              {productCanvas && (
                <span className="w-50">
                  <Button
                    onClick={() => handleDispose()}
                    className="w-100"
                    variant="warning"
                  >
                    Dispose
                  </Button>
                </span>
              )}
              <span
                className="w-50 d-flex gap-3"
                style={{ cursor: !orderLink && "not-allowed" }}
              >
                <Button
                  variant={orderLink ? "info" : "secondary"}
                  className="flex-1 "
                  onClick={() => {
                    const  duplicateData = ["43924864598194","37547358453938", "37997006225586","40624818257968", "41407549177904"];
                    let productCount = 0;
                    Object.entries(cart).forEach(([id, count]) => {
                      if(duplicateData.includes(id)){
                        productCount+=1;
                      }
                    });
                    if(productCount>1){
                      toast.info("You can only add one item at a time. Please select either minoxidil or minoxidil tablet");
                      return;
                    }
                    generateCartLink(
                      case_id,
                      orderLink,
                      cartValue,
                      setToaster,
                      setShowCopy
                    );
                  }}
                >
                  Send
                </Button>
                {showCopy && (
                  <Button
                    className="flex-1"
                    variant="outline-secondary"
                    id="button-addon2"
                    onClick={handleCopyOrderLink}
                  >
                    {copyButton}
                  </Button>
                )}
              </span>
            </div>
          ) : (
            <p className="fw-bold text-danger text-center">
              At least select one product to place order
            </p>
          )}
        </Row>
      </Form>
    </div>
  );
}

export default PlacedOrderForm;
